// (c) 2023 Acellera Ltd http://www.acellera.com
// All Rights Reserved
// No redistribution in whole or part
//
import { QueueJob } from "molkitstar-ui";

const statusLabels = {
  0: "Waiting data",
  1: "Validating",
  2: "Waiting approval",
  3: "Running",
  4: "Completed",
  5: "Error",
  6: "Queued",
  7: "Sleeping",
};

export function parseUserJobInfo(jobData: any) {
  return {
    container: jobData.container,
    appid: jobData.appid,
    date: "",
    parentId: jobData.parentid !== "" ? jobData.parentid : "-",
    status: statusLabels[Number(jobData.status) as keyof typeof statusLabels],
    traceId: jobData.id,
    shortTraceId: jobData.id.substring(0, 8).toUpperCase(),
    userName: "-",
    name: jobData.name,
    output_id: "-",
    error_info: jobData.error_info,
    progressper: jobData["progressper"],
    progressinfo: jobData["progressinfo"],
    children: undefined,
  };
}

function formatJobDate(dateString: string): string {
  const date = new Date(dateString);
  const month = date.toLocaleString("en-US", { month: "long" });
  const day = date.getDate();
  const year = date.getFullYear();
  const hour = date.getHours();
  const minute = date.getMinutes();
  const second = date.getSeconds();
  const ampm = hour >= 12 ? "PM" : "AM";
  const formattedHour = hour % 12 || 12;

  const formattedDate = `${month} ${day}, ${year} at ${formattedHour}:${minute
    .toString()
    .padStart(2, "0")}:${second.toString().padStart(2, "0")} ${ampm}`;
  return formattedDate;
}

export function parseQueueJobInfo(jobs: { [id: string]: any }[]) {
  const ans: QueueJob[] = [];
  const child2par: { [id: string]: string } = {};

  for (const job of jobs) {
    child2par[job.id] = job.parentid;
  }
  // Find the first real father
  for (const k in child2par) {
    let parentid = child2par[k];
    while (true) {
      if (parentid in child2par && child2par[parentid] !== "") {
        parentid = child2par[parentid]; // Parent of the parent
        child2par[k] = parentid;
      } else {
        break;
      }
    }
  }

  for (const job of jobs) {
    const parentid =
      child2par[job.id] && child2par[job.id].length > 0
        ? child2par[job.id]
        : job.id;

    const fmtJob: QueueJob = {
      traceId: job.id.substring(0, 8).toUpperCase(),
      parentId: parentid.substring(0, 8).toUpperCase(),
      // userName: job.user!,
      container: job.container.split("_")[0],
      status: statusLabels[Number(job.status) as keyof typeof statusLabels],
      formattedDate: formatJobDate(job.date),
      date: job.date,
      progress: job.progressper !== "" ? job.progressper : "NA",
      userID: job.userid,
    };
    ans.push(fmtJob);
  }

  // Sort by newest first
  const queueJobs = ans.sort(
    (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
  );
  return queueJobs;
}
